import LogoInstantPay from '../assets/LogoInstantPay.svg';
import SmallLogoInstantPay from '../assets/instantPaySmallIcon.svg';
import IconLogoInstantPay from '../assets/instantPaySmallIcon.svg';
import LogoFinpos from '../assets/finpos_lg.png';
import SmallLogoFinpos from '../assets/finpos_sm.png';
import IconLogoFinpos from '../assets/finpos_icon.png';
import InstantPayLoader from '../assets/instantpay_loader.gif';
import FinposLoader from '../assets/finpos_loader.gif';
import FaviconInstantPay from '../assets/Instantpay-favicon.png';
import FaviconFinpos from '../assets/finpos-favicon.png';

let date = new Date();
let year = date.getFullYear();

export const THEME = {
  INSTANTPAY: {
    brand: 'Citytech',
    title: 'Instant Pay',
    year: year,
    logo: LogoInstantPay,
    smallLogo: SmallLogoInstantPay,
    iconLogo: IconLogoInstantPay,
    favIcon: SmallLogoInstantPay,
    loader: InstantPayLoader,
    AutoCloseMobileNav: true, // Boolean: true, false. Automatically close sidenav on route change (Mobile only)
    customizer: true, // Boolean: true, false. Customizer will be removed completely when set to false
    showCustomizer: false, // Boolean: true, false. Customizer will be opened (visible) first time app was loaded if set to true
    color: {
      primary: '#A34343',
      secondary: '#fce6e8',
      linkHover: '#A34343',
      btnHover: '#ea5a62',
      graphColorPallete: ['#A34343', '#DA7A7A', '#FF7676', '#FFBCBC', '#FCE6E8', '#7B040C'],
      topbar: '#A34343',
      sidebar: '#fce6e8',
      // success: '#66BB6A',
      // info: '#0747a6',
      // infoAlt: '#948aec',
      // warning: '#ffc53d',
      // danger: '#ff4d4f',
      // text: '#3D4051',
      // gray: '#EDF0F1',
    },
    settings: {
      layout: '1', // String: 1, 2, 3, 4 and add your own
      boxedLayout: false, // Boolean: true, false
      fixedSidenav: false, // Boolean: true, false
      fixedHeader: false, // Boolean: true, false
      collapsedNav: false, // Boolean: true, false
      offCanvasNav: false, // Boolean: true, false
      sidenavWidth: 240, // Number
      offCanvasMobileNav: true, // Boolean: true, false. Mobile only, by default, it's true (off canvas)
      colorOption: '34', // String: 11,12,13,14,15,16; 21,22,23,24,25,26; 31,32,33,34,35,36
      theme: 'light', // (WIP) String: light, gray, dark
    },
  },
  FINPOS: {
    brand: 'Citytech',
    title: 'finPos Platform',
    year: year,
    logo: LogoFinpos,
    smallLogo: SmallLogoFinpos,
    iconLogo: IconLogoFinpos,
    favIcon: FaviconFinpos,
    loader: FinposLoader,
    AutoCloseMobileNav: true, // Boolean: true, false. Automatically close sidenav on route change (Mobile only)
    customizer: true, // Boolean: true, false. Customizer will be removed completely when set to false
    showCustomizer: false, // Boolean: true, false. Customizer will be opened (visible) first time app was loaded if set to true
    color: {
      primary: '#7177B9',
      secondary: '#7ACDEF',
      linkHover: '#1890ff',
      btnHover: '#7acceb',
      graphColorPallete: ['#88c4cc', '#c4bcdc', '#969cb3', '#bbecf5', '#7bccec', '#7476b8'],
      topbar: '#7177B9',
      sidebar: '#e6f7ff',
      // success: '#66BB6A',
      // info: '#0747a6',
      // infoAlt: '#948aec',
      // warning: '#ffc53d',
      // danger: '#ff4d4f',
      // text: '#3D4051',
      // gray: '#EDF0F1',
    },
    settings: {
      layout: '1', // String: 1, 2, 3, 4 and add your own
      boxedLayout: false, // Boolean: true, false
      fixedSidenav: false, // Boolean: true, false
      fixedHeader: false, // Boolean: true, false
      collapsedNav: false, // Boolean: true, false
      offCanvasNav: false, // Boolean: true, false
      sidenavWidth: 240, // Number
      offCanvasMobileNav: true, // Boolean: true, false. Mobile only, by default, it's true (off canvas)
      colorOption: '34', // String: 11,12,13,14,15,16; 21,22,23,24,25,26; 31,32,33,34,35,36
      theme: 'light', // (WIP) String: light, gray, dark
    },
  },
};
